import React from 'react'
import classNames from "classnames/bind"

import styles from './not-found-page.module.scss';

const cx = classNames.bind(styles)

export const NotFoundPage = () => {
    return (
        <div className={cx(['container', 'not-found-wrapper'])}>
            <h1>404: Page Not Found</h1>
            <p>Looks like you tried looking for a page that doesn't exist within this website. Please try a different page.</p>
        </div>
    )
}